<template>
    <div class="relative w-full">
        <img
            :src="hero.landing_hero_image"
            :alt="hero.landing_hero_image_alt"
            class="relative w-full h-[400px] lg:h-[574px] object-cover"
        />
        <div class="absolute bg-black bg-opacity-45 backdrop-blur-sm h-full w-full top-0"></div>
        <div class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 text-center w-full lg:w-fit">
            <h2>
                {{ hero.h1 }}
            </h2>
            <h2 class="text-gray-100 text-body-md leading-5 mb-6 tracking-wider">
                {{ hero.description }}
            </h2>
            <div @click="navigate">
                <AppButton
                    class="px-6 py-2 !bg-gray-100 !text-brand-500 rounded-full mx-auto"
                    color="brand"
                    variant="ghost"
                    >{{ hero.cta_text }}</AppButton
                >
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import type { IHeroSection } from "~/types/pages/landing-page";

// * interface
interface Props {
    hero: IHeroSection;
}

// * props
defineProps<Props>();
const localePath = useLocalePath();
const navigate = () => {
    navigateTo(localePath("/dashboard/services"));
};
</script>
